import * as React from "react";

function ExclamationTriangle(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 66 56" fill="none" {...props}>
      <path
        d="M65.241 50.433l-29.066-48.4c-1.402-2.356-4.947-2.356-6.374 0L.785 50.433c-1.402 2.356.357 5.314 3.187 5.314H62.08c2.804 0 4.564-2.958 3.161-5.314zM34.57 47.9c-.485.251-.995.426-1.581.426-.587 0-1.097-.175-1.581-.426-1.046-.551-1.785-1.579-1.785-2.807 0-1.78 1.504-3.233 3.366-3.233 1.861 0 3.365 1.454 3.365 3.233.026 1.228-.74 2.256-1.785 2.807zm1.886-18.598v2.732c0 1.83-1.555 3.309-3.442 3.309-1.912 0-3.442-1.479-3.442-3.309V16.02c0-1.83 1.555-3.309 3.442-3.309 1.913 0 3.442 1.48 3.442 3.309v13.284z"
        fill={props.color||"red"}
      />
    </svg>
  );
}

export default ExclamationTriangle;
